import React, { useState, useEffect } from 'react';
import driverService from '../../services/driverService';
import communicationService, { COMM_EVENT_KEYS } from '../../services/communicationService';
import toast from 'react-hot-toast';

const INITIAL = { full_name: '', email: '', phone: '', license_number: '', license_expiry: '', status: 'active', nhif_number: '', national_id: '' };

export default function DriverForm({ driver, onSuccess, onCancel }) {
  const [form, setForm]   = useState(INITIAL);
  const [sendEmail, setSendEmail] = useState(true);
  const [loading, setLoading] = useState(false);
  const isEdit = Boolean(driver);

  useEffect(() => { if (driver) setForm({ ...INITIAL, ...driver }); }, [driver]);

  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const saved = isEdit
        ? await driverService.update(driver.id, form)
        : await driverService.create(form);

      if (sendEmail && form.email) {
        try {
          await communicationService.dispatchEvent(COMM_EVENT_KEYS.DRIVER_ONBOARDING, {
            driver_id: saved?.id || driver?.id,
            email: form.email,
            context: { action: isEdit ? 'driver_updated' : 'driver_created' },
          });
        } catch {
          toast.error('Driver saved, but email dispatch is not configured');
        }
      }

      toast.success(isEdit ? 'Driver updated' : 'Driver added');
      onSuccess();
    } catch (err) {
      const d = err.response?.data;
      if (d) Object.values(d).forEach(v => toast.error(Array.isArray(v) ? v[0] : v));
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit}>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">Full Name *</label>
          <input className="form-control" name="full_name" value={form.full_name} onChange={handle} required />
        </div>
        <div className="form-group">
          <label className="form-label">Phone *</label>
          <input className="form-control" name="phone" value={form.phone} onChange={handle} placeholder="+254 7xx xxx xxx" required />
        </div>
      </div>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-control" type="email" name="email" value={form.email} onChange={handle} />
        </div>
        <div className="form-group">
          <label className="form-label">National ID</label>
          <input className="form-control" name="national_id" value={form.national_id} onChange={handle} />
        </div>
      </div>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">License Number</label>
          <input className="form-control" name="license_number" value={form.license_number} onChange={handle} />
        </div>
        <div className="form-group">
          <label className="form-label">License Expiry</label>
          <input className="form-control" type="date" name="license_expiry" value={form.license_expiry} onChange={handle} />
        </div>
      </div>
      <div className="form-group">
          <label className="form-label">NHIF Number</label>
          <input className="form-control" name="nhif_number" value={form.nhif_number} onChange={handle} />
      </div>
      <div className="form-group">
        <label className="form-label">Status</label>
        <select className="form-control" name="status" value={form.status} onChange={handle}>
          <option value="active">Active</option>
          <option value="on_leave">On Leave</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
      <div className="form-group">
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: 'var(--gray-600)' }}>
          <input
            type="checkbox"
            checked={sendEmail}
            onChange={(e) => setSendEmail(e.target.checked)}
          />
          Send onboarding/update email
        </label>
      </div>
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving…' : isEdit ? 'Update Driver' : 'Add Driver'}
        </button>
      </div>
    </form>
  );
}